<script>
  import { MessageSquare } from 'lucide-svelte';

  export let iconClass = '';
</script>

<MessageSquare class={iconClass} />
